import React from 'react';

import css from './CommentReactionButton.module.scss';
import {classNames} from '~/src/utilities/helpers/css';

const CommentReactionButton = ({reaction, label, count, onClick, colors = {}, selected = false}) => {
    const style = {
        color: colors.light
    };

    const className = classNames(css, 'button', {selected});

    return (
        <button className={className} style={style} onClick={() => onClick(reaction)}>
            <span className={css.label} data-count={count}>
                {label}
            </span>
        </button>
    );
};

export default CommentReactionButton;
